import BaseApiClient from '@api-client/BaseApiClient';
import {
  DocuSignDirectors,
  DocuSignEmbeddedView
} from '@interfaces/FlightPlan';

export class ApiFlightPlan extends BaseApiClient {
  getflightPlan<T>(path: string): Promise<T> {
    return new Promise((resolve, reject) => {
      this.client
        .get(`flight-plan/${path}`)
        .then((res) => resolve(res.data))
        .catch(reject);
    });
  }

  getDocuSignDirectors(): Promise<DocuSignDirectors[]> {
    return new Promise((resolve, reject) => {
      this.client
        .get('/kyb/toba-signatory-list')
        .then((res) => resolve(res.data.data))
        .catch(reject);
    });
  }

  getEmbeddedView({ id }: DocuSignDirectors): Promise<DocuSignEmbeddedView> {
    return new Promise((resolve, reject) => {
      this.client
        .get(`/docu-sign/embedded-view?director_id=${id}`)
        .then((res) => resolve(res.data))
        .catch(reject);
    });
  }

  async storeDocuSignEmail(dto: DocuSignDirectors): Promise<DocuSignDirectors> {
    return new Promise((resolve, reject) => {
      this.client
        .post('/docu-sign/send-email', dto)
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  async storeSignContract(dto: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.client
        .post('/signContract', dto)
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { flightPlanQueryKeys } from './query-keys';
export {
  useFlightPlanByPathQuery,
  useFlightPlanDocuSignDirectorsQuery,
  useFlightPlanEmbeddedViewQuery
} from './use-flight-plan-queries';
export {
  useFlightPlanStoreDocuSignEmailMutation,
  useFlightPlanStoreSignContractMutation
} from './use-flight-plan-mutations';
